import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IDivider {
  width?: string;
  height?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;
